module.exports = __webpack_public_path__ + "img/dropbox.05939749.svg";